import { Clock, Effect, Option, Result } from "effect";
import { occurredAt } from "../../widgets/addEntry";
import type { Entry } from "../schemas/entries";
import { addEntry } from "./entries";

/** Shared by the timeline and quick capture; clocks and HTTP stay at the command boundary. */
export const createNoteEntry = (
	nodeId: string,
	note: Readonly<{
		type: string;
		title: string;
		body: string;
		tags: ReadonlyArray<string>;
		/** `YYYY-MM-DD`; absent or none means now (R1). */
		occurredOn?: Option.Option<string>;
	}>,
) =>
	Effect.gen(function* () {
		const milliseconds = yield* Clock.currentTimeMillis;
		const entry: Omit<Entry, "id"> = {
			circleId: "1",
			nodeIds: [nodeId],
			type: note.type,
			title: note.title,
			description: note.body,
			tags: [...new Set([note.type, ...note.tags])],
			timestamp: occurredAt(note.occurredOn ?? Option.none(), milliseconds),
		};
		const result = yield* addEntry.run({ data: entry });
		return Result.map(
			result,
			(response): Entry => ({
				...entry,
				id:
					typeof response === "object" &&
					response !== null &&
					"created" in response &&
					typeof response.created === "string"
						? response.created
						: "",
			}),
		);
	});
